var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H2.5C1.83696 20 1.20107 19.7366 0.732233 19.2678C0.263392 18.7989 0 18.163 0 17.5V0H1.66667V17.5C1.66667 17.721 1.75446 17.933 1.91074 18.0893C2.06702 18.2455 2.27899 18.3333 2.5 18.3333H20V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 9.16719H11.6664V16.6672H13.3331V9.16719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 9.16719H5V16.6672H6.66666V9.16719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5H15V16.6667H16.6667V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5H8.33359V16.6667H10.0003V5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.69dccf03.svg";
export { ForwardRef as ReactComponent };